import { BaseDeviceWrapper } from "./BaseDeviceWrapper";
import image from "images/devices/sam-promotion.png";

const serviceUuid = 0xae00;
const characteristicUuid = 0xae01;
const confirmCharacteristicUuid = 0xae02;

const DEVICE_NAME = "Sam Neo";

/**
 * Create a device wrapper over the Web Bluetooth device object
 * @param {obj} webBleDevice - Web Bluetooth device object
 */
export default class Svakom extends BaseDeviceWrapper {
  constructor(device, isSendingData) {
    super(device, serviceUuid, characteristicUuid, image, isSendingData);
  }

  static get deviceNames() {
    return DEVICE_NAME;
  }

  /**
   * Needed to request access to these services before connecting to the device
   */
  static get services() {
    return [serviceUuid];
  }

  get companyName() {
    return "Svakom";
  }

  async write(percent) {
    percent = Math.max(0, Math.min(100, percent));
    const intensity = Math.round((percent * 10) / 100);
    const data = [0x12, 0x01, 0x03, 0x00, intensity ? 0x04 : 0, intensity];
    const array = new Uint8Array(data);
    await this.motorChar.writeValue(array);
  }

  async connect() {
    try {
      const result = await super.connect(
        this.getConfirmCharacteristics.bind(this)
      );
      return result;
    } catch (e) {
      return Promise.reject("connect Sam Neo e: " + e);
    }
  }

  async getConfirmCharacteristics() {
    this.sensorChar = await this.sensorService.getCharacteristic(confirmCharacteristicUuid);
    await this.sensorChar.startNotifications();
  }

  async turnOffSuction() {
    const mode = 0;
    const data = [0x12, 0x06, 0x01, mode];
    const array = new Uint8Array(data);
    await this.motorChar.writeValue(array);
  }
}
